import { OneTimePayment } from "../../../../services/api";

// The Pix/boleto just created, kept for the screen that shows it: it survives a reload of that screen (this
// tab only). Nothing sensitive: the same code/line the person is about to pay
const key = (paymentIntentId: string) => `keepo.pendingPayment.${paymentIntentId}`;

// Also in memory, for when the browser storage isn't available
let lastPayment: OneTimePayment | undefined;

export const savePendingPayment = (payment: OneTimePayment) => {
  lastPayment = payment;
  try {
    sessionStorage.setItem(key(payment.paymentIntentId), JSON.stringify(payment));
  } catch {
    // Storage unavailable (private mode): the screen still gets it from memory
  }
};

export const loadPendingPayment = (paymentIntentId: string): OneTimePayment | undefined => {
  if (lastPayment?.paymentIntentId === paymentIntentId) {
    return lastPayment;
  }
  try {
    const saved = sessionStorage.getItem(key(paymentIntentId));
    return saved ? (JSON.parse(saved) as OneTimePayment) : undefined;
  } catch {
    return undefined;
  }
};

/**
 * A bank boleto's line (47 digits) in its usual groups: 00000.00000 00000.000000 00000.000000 0 00000000000000.
 * Anything else (already formatted, another kind of boleto) is shown as it comes.
 */
export const formatBoletoLine = (line: string) => {
  const digits = line.replace(/\D/g, "");
  if (digits.length !== 47) {
    return line;
  }
  return `${digits.slice(0, 5)}.${digits.slice(5, 10)} ${digits.slice(10, 15)}.${digits.slice(15, 21)} ${digits.slice(21, 26)}.${digits.slice(26, 32)} ${digits[32]} ${digits.slice(33)}`;
};
